<h3 mat-dialog-title>{{data.titolo | translate | uppercase}}</h3>
<div mat-dialog-content>
    <form class="pt-1">
        <mat-form-field class="w-100" appearance="outline">
            <mat-label>
                {{'promodialogo.titoloRegalo' | translate}}
            </mat-label>
            <input matInput placeholder="{{data.label | translate}}" [formControl]="codiceFormControl">
            <mat-error *ngIf="codiceFormControl.hasError('required')">
                {{'generale.richiesto' | translate}}
            </mat-error>
        </mat-form-field>
    </form>
    <div *ngIf="risultato && !risultato.risultato" class="alert">
        {{risultato.errore | translate}} <span *ngIf="risultato && risultato.data1"> {{risultato.data1 | localizedDate}}
            {{'promodialogo.scadutarange2' | translate}} {{risultato.data2 | localizedDate}}</span>
        {{ risultato.errore == 'promodialogo.importominimo' ? '€' + risultato.promo.minimo : ''}}
    </div>

</div>
<div mat-dialog-actions>
    <div class="row">
        <button class="btn btn__riscatta" (click)="riscatta()" [disabled]="!form.valid" cdkFocusInitial>
            {{'promodialogo.button' | translate}}
        </button>
        <button class="btn btn__undo" (click)="onNoClick()">
            <span class="material-symbols-outlined">
                close
            </span>
        </button>
    </div>
</div>